import { DirectoryResponse, getDirectory } from "../../api";
import { useCallback, useContext, useEffect, useState } from "react";
import { SessionTokenContext } from "../../contexts/SessionTokenContext";
import { AxiosError } from "axios";

export type useResidentsListProps = {
  data?: DirectoryResponse;
  error?: AxiosError;
  isLoading?: boolean;
  refetch: () => Promise<void>;
};

const useResidentsList = () => {
  const { sessionTokenWrapper, tokenExpirationWrapper } =
    useContext(SessionTokenContext);
  const [sessionToken] = sessionTokenWrapper;
  const [, setTokenExpiration] = tokenExpirationWrapper;
  const [data, setData] = useState<DirectoryResponse>();
  const [error, setError] = useState<AxiosError>();
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const getResidentsData = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await getDirectory(sessionToken, setTokenExpiration);
      setData(response);
    } catch (err) {
      setError(err as AxiosError);
    } finally {
      setIsLoading(false);
    }
  }, [sessionToken, setTokenExpiration]);

  useEffect(() => {
    // initial call to get residents list
    if (sessionToken && !data) {
      getResidentsData();
    }
  }, [data, getResidentsData, sessionToken]);

  return {
    data,
    error,
    isLoading,
    refetch: getResidentsData,
  } as useResidentsListProps;
};

export default useResidentsList;
